
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/common/components/ui/button';

const Home: FC = () => {
  return (
    <div className="space-y-16 md:space-y-24">
      {/* Hero Section */}
      <section className="grid md:grid-cols-2 gap-12 items-center">
        <div className="space-y-4 md:text-left text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900">Spencer Hardesty Lewis</h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl">
            Juris Doctor Candidate with a background in strategic communications and public policy.
          </p>
          <div className="mt-6 flex gap-4 justify-center md:justify-start">
            <Button asChild>
              <Link to="/resume">View Resume</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/contact">Contact Me</Link>
            </Button>
          </div>
        </div>
        <div className="flex justify-center">
          <img 
            src="/assets/images/headshot.jpg" 
            alt="Spencer Hardesty Lewis" 
            className="rounded-full shadow-lg w-64 h-64 md:w-80 md:h-80 object-cover border-4 border-white"
          />
        </div>
      </section>

      {/* Highlights Section */}
      <section className="space-y-10">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800">Highlights</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {/* Card 1: Education */}
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Legal Education</h3>
            <p className="text-gray-700">
              Currently a J.D. Candidate at Loyola University New Orleans College of Law, ranking in the top third of the class.
            </p>
          </div>
          {/* Card 2: Experience */}
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Communications Director</h3>
            <p className="text-gray-700">
              Managed all internal and external communications for Galveston County, including crisis communications during major weather events.
            </p>
          </div>
          {/* Card 3: Skills */}
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Multilingual</h3>
            <p className="text-gray-700">
              Proficient in Spanish and possesses an intermediate understanding of German, facilitating international communication.
            </p>
          </div>
        </div>
      </section>

      {/* Experience Preview Section */}
      <section className="text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800">Professional Experience</h2>
        <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
          A proven track record of leadership and strategic thinking across government, political, and legal fields.
        </p>
        <div className="mt-8">
          <Button asChild>
            <Link to="/resume">Explore My Experience</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Home;
